/**
 * User Themes Page
 * 
 * Page for users to create and manage their custom color themes.
 */

import React from 'react';
import { ContentLayout } from '@cloudscape-design/components';
import UserThemeCreator from '../components/themes/UserThemeCreator';

const UserThemes: React.FC = () => {
  return (
    <ContentLayout>
      <UserThemeCreator />
    </ContentLayout>
  );
};

export default UserThemes;
